<template>
  <Badge
    v-if="status !== MediaEncodingStatus.READY"
    :variant="MEDIA_ENCODING_STATUS_VARIANT[status]"
    :size="size"
  >
    {{ t(`mediaEncodingStatus.${status}`) }}
  </Badge>
</template>

<script setup lang="ts">
import Badge from '@/components/Badge.vue';
import type { BadgeVariant } from '@carvia/theme/lib/cva/badge';
import { MediaEncodingStatus } from '@carvia/ros-client-types';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  status: MediaEncodingStatus;
  size?: 'sm' | 'md';
}>();

const MEDIA_ENCODING_STATUS_VARIANT: Record<
  Exclude<MediaEncodingStatus, MediaEncodingStatus.READY>,
  BadgeVariant
> = {
  [MediaEncodingStatus.PENDING]: 'neutral',
  [MediaEncodingStatus.PROCESSING]: 'warning',
  [MediaEncodingStatus.FAILED]: 'problem',
};
</script>
